<template>
  <label
    :class="{ invalid: showError && !disabled }"
    class="sf-checkbox"
    @click.self.prevent>
    <input
      v-model="model"
      type="checkbox"
      class="sf-checkbox__box sf-checkmark"
      @change="$emit('change', model)">
    <div class="sf-checkbox__label" @click.prevent="onClickLabel">
      <slot/>
    </div>
  </label>
</template>

<script>
import Field from './field.vue';

export default {
  extends: Field,
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    model(value) {
      this.$emit('input', value);
      const time = Date.now();
      if (this.behaviourCapture.eventStart === null) {
        this.behaviourCapture.eventStart = time;
        this.behaviourCapture.firstValue = value;
      }
      this.behaviourCapture.eventEnd = time;
    },
  },
  methods: {
    setValue(value) {
      this.model = value;
    },
    onClickLabel({ target }) {
      let linkTarget = target;

      let detailsTarget = target;

      let i = 0;

      let link = null;

      let details = null;

      while (i < 5 && !link && linkTarget.parentNode) {
        linkTarget instanceof HTMLAnchorElement && (link = linkTarget);
        linkTarget = linkTarget.parentNode;
        i++;
      }

      i = 0;

      while (i < 3 && !details && detailsTarget.parentNode) {
        detailsTarget instanceof HTMLDetailsElement && (details = detailsTarget);
        detailsTarget = detailsTarget.parentNode;
        i++;
      }

      if (link) {
        window.open(link.getAttribute('href'), link.getAttribute('target') || '_self');
      } else if (details) {
        details.open ? (details.open = false) : (details.open = true);
      }
    },
  },
};
</script>
